export default __webpack_public_path__ + "static/media/IMG19.15f6ca7a.jpg";